import { Fragment, ReactElement, useEffect } from 'react';
import { Location, useLocation } from 'react-router-dom';

import { customerRoutes } from 'noddi-util';
import { tracking } from 'noddi-web/src/tracking';
import { useGetBookingTrackingParams } from './hooks/useGetBookingTrackingParams';

// Component so that we can create funnels with screen trackings in mixpanel
// Its recommended that this is a JSX component and not hook from docs by mixpanel
export function TrackScreen(): ReactElement {
  const location = useLocation();
  const bookingParams = useGetBookingTrackingParams();

  useEffect(() => {
    const { pathname, searchParams } = getTrackingPathFromLocation(location);

    // we dont want to track events for new booking because we have a custom one for it
    // See TrackBookingScreen.tsx in components/BookingFlow for more details
    if (pathname.includes(customerRoutes.newBooking.getPath())) {
      tracking.track(pathname, { ...searchParams, ...bookingParams });
    } else {
      tracking.track(pathname, searchParams);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return <Fragment />;
}

function getTrackingPathFromLocation(location: Location) {
  const pathname = location.pathname;
  const search = location.search;
  const searchParams = location.search ? { search: search.replace('?', '') } : undefined;
  return { pathname, searchParams };
}
